import { useVahakMutationQuery } from '../hooks/useVahakQueryClient.js';
import useVahakHttpClient from '../hooks/useVahakHttpClient.js';
import API from './const.js';
import { QueryNames } from './hooks/queryNames.js';

var HelpRequestScreen;
(function (HelpRequestScreen) {
    HelpRequestScreen["CONTACT_US"] = "Contact Us Page (Web)";
    HelpRequestScreen["SUPPORT_ICON"] = "Support Floating Icon (Web)";
    HelpRequestScreen["LOAD_BID"] = "Load Bid Form (Web)";
    HelpRequestScreen["LORRY_BID"] = "Lorry Bid Form (Web)";
    HelpRequestScreen["COMPANY_REGISTER"] = "Company Register (Web)";
})(HelpRequestScreen || (HelpRequestScreen = {}));
const useHelpRequestTicket = () => {
    const { POST } = useVahakHttpClient();
    function method(data) {
        return POST(API.TICKET_HELP_REQUEST, Object.assign({}, data));
    }
    return useVahakMutationQuery(QueryNames.helpRequest, method);
};

export { HelpRequestScreen, useHelpRequestTicket };
//# sourceMappingURL=help.service.js.map
